import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projects: []
  },
  mutations: {
    SAVE_PROJECTS (state, results) {
      results.sort((a, b) => (a.data.project_order > b.data.project_order) ? 1 : -1);

      state.projects = results;
    }
  },
  getters: {
    randomProject: state => {
      var randomIndex = Math.floor(Math.random() * state.projects.length);

      return { project: state.projects[randomIndex], index: randomIndex };
    },
    hasPhotos: state => {
      return (state.projects.length > 0);
    }
  },
  actions: {
    async fetchProjects (context, {vm, cb}) {
      if (this.state.projects.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'project'), { orderings : '[project.project_order]' }
        ).then((response) => {
          // console.log(response.results);
          // response is the response object, response.results holds the documents
          context.commit('SAVE_PROJECTS', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.projects);
      }

      // var mock_data = [
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'Google Chromecast',
      //     title: 'Google',
      //     uid: '0',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'adidas China Creators Unite',
      //     title: 'adidas',
      //     uid: '1',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     title: 'EartH',
      //     uid: '2',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'Uber Rides',
      //     title: 'Uber',
      //     uid: '3',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'adidas FW19 Boost',
      //     title: 'adidas',
      //     uid: '4',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'Smirnoff Infusions',
      //     title: 'Smirnoff',
      //     uid: '5',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'adidas China 70th Anniversary',
      //     title: 'adidas',
      //     uid: '6',
      //     bg_placement: 'center'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     // title: 'Ebay UK',
      //     title: 'Ebay',
      //     uid: '7',
      //     bg_placement: 'top'
      //   },
      //   {
      //     // img: 'audi.jpeg',
      //     img: 'smirnoff.gif',
      //     title: 'Klarna',
      //     uid: '8',
      //     bg_placement: 'center'
      //   }
      // ];

      // context.commit('SAVE_PROJECTS', mock_data);
      // cb(mock_data);
    },
    saveProjects (context, projects) {
      return new Promise((resolve) => {
        context.commit('SAVE_PROJECTS', projects);
        resolve();
      });
    }
  }
})
